export const Legend = () => (
    <div className="legend">
        <h4>Legend</h4>
        <div className="legend-items">
            <p className="chef-recommended-container">
                <span className="heart" />
                <span>= Chef Recommended</span>
            </p>
            <p className="chef-wip-container">
                <span className="wip" />
                <span>= Cooking in Progress</span>
            </p>
        </div>
    </div>
)